<template>
  <div id="ClientsList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 fixed-t">
      <div class="col-12 lh40 bg-color-white b-s-2 pl5 pr5">
        <div class="col-3 f18" @click="go_home()"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">C</span>lientes</div>
        <div class="col-3 t-r f26"></div>
      </div>
      <div class="col-12 bg-color-white bb1">
        <div class="col-3 t-c lh40 f13" :class="data_status === 'all' ? 'color-primary fw bb3-primary' : 'color-muted'" @click="statusCh('all')">Todas</div>
        <div class="col-3 t-c lh40 f13" :class="data_status === 1 ? 'color-primary fw bb3-primary' : 'color-muted'" @click="statusCh(1)">Activo</div>
        <div class="col-3 t-c lh40 f13" :class="data_status === 0 ? 'color-primary fw bb3-primary' : 'color-muted'" @click="statusCh(0)">Inactivo</div>
        <div class="col-3 t-c lh40 f13" :class="data_status === -1 ? 'color-primary fw bb3-primary' : 'color-muted'" @click="statusCh(-1)">Bloqueado</div>
      </div>
    </div>
    <div class="h8"></div>
    <div class="col-12" :style="{ height: $store.state.body_h + 'px'}" style="overflow-y: auto;">
      <div class="col-12 pl5 pr5 mt5" v-for="(client,client_i) in data_list" v-bind:key="client_i" @click="go_client(client.appid)">
        <div class="col-12">
          <div class="col-12 bg-color-white r5 p5">
              <div class="col-2 f40 color-primary br1 t-c">
                <i class="iconfont icon-lock color-muted" v-if="client.status == -1"></i>
                <i class="iconfont icon-error color-danger" v-else-if="client.status == 0"></i>
                <i class="iconfont icon-jinrudianpu" v-else></i>
              </div>
              <div class="col-9 pl10">
                <div class="col-12 f14">
                  {{client.license_type}}{{ client.license }}
                  <span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5" v-if="client.is_specials == 1">C.E</span>
                  <span class="bg-color-muted color-white f12 pt1 pb1 pl3 pr3 r5 ml3" v-if="client.status == -1">Bloqueado</span>
                  <span class="bg-color-danger color-white f12 pt1 pb1 pl3 pr3 r5 ml3" v-else-if="client.status == 0">Inactivo</span>
                  <span class="bg-color-success color-white f12 pt1 pb1 pl3 pr3 r5 ml3" v-else-if="client.status == 1">Activo</span>
                </div>
                <div class="col-12 fw f16"><span class="bg-color-muted color-white f12 pt1 pb1 pl5 pr5 r50 mr3">{{ client.store}}</span>{{ client.enterprise_name }}</div>
                <div class="col-12 color-muted f12">{{ client.update_time}}</div>
              </div>
              <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div class="h5"></div>
    <div ref="app_foot" class="col-12 fixed-b t-c color-white f14 bg-color1 lh50 t-c-v">
      <div class="fl"><input type="text" class="bg-color-white h4 b-s-2 r5 pl5 pr5 w28" placeholder="RIF" v-model="keyword"></div>
      <div class="b-s-2 r5 w4 h4 fl bg-color-white t-c-v f26 ml5" :class="[keyword != '' && keyword.length > 1?'color-primary fw':'color2']" @click="get_list_data()"><i class="iconfont icon-search"></i></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ClientsList',
  data () {
    return {
      keyword: '',
      new_store: false,
      data_list: [],
      data_status: 'all',
    }
  },
  created: function () {
    this.keyword = this.$store.state.client_keyword;
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var keyword = this.keyword;
      if(keyword < 2){
        //return;
      }
      var post_data = {};
      post_data.keyword = keyword;
      post_data.status = this.data_status;
      this.new_store = false;
      this.post(this.api_url + 'Tec/clients', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data;
          this.$store.commit('setClientKeyword', keyword);
          this.$nextTick(() => {
            this.$store.commit('setBodyH', this);
          });
        }else{
          this.data_list = []
          if(res.status == 2){
            this.$router.push({name:'Activation',params:{rif: res.data, act_type: 0}});
          }
        }
      })
    },
    statusCh(status){
      if(this.data_status === status){
        return;
      }
      this.data_status = status;
      this.get_list_data();
    },
    go_client(appid){
      this.$router.push({name:'T_Client',query:{appid: appid}});
    },
    go_home(){
      this.$router.push({name:'Technician'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Technician/ClientsList.vue